import {
  ADD_PS_CALCULATOR_ITEM,
  EDIT_PS_CALCULATOR_ITEM,
  DELETE_PS_CALCULATOR_ITEM,
  GET_PS_CALCULATOR_ITEMS,
  GET_PS_CALCULATOR_DOC_URL,
} from "./action";

const initialState = {
  items: [],
  loading: false,
};

export default function psCalculatorReducer(state = initialState, action) {
  switch (action.type) {
    case ADD_PS_CALCULATOR_ITEM:
      return {
        ...state,
        items: action.payload.ps_calculator
          ? [...state.items, action.payload.ps_calculator]
          : state.items,
        loading: action.payload.loading,
      };
    case EDIT_PS_CALCULATOR_ITEM:
      return {
        ...state,
        items: action.payload.item?.ps_calculator
          ? state.items.map((item) =>
              item.id === action.payload.item.ps_calculator.id
                ? action.payload.item.ps_calculator
                : item,
            )
          : state.items,
        loading: action.payload.loading,
      };
    case DELETE_PS_CALCULATOR_ITEM:
      return {
        ...state,
        items: action.payload.id
          ? state.items.filter((item) => item.id !== action.payload.id)
          : state.items,
        loading: action.payload.loading,
      };
    case GET_PS_CALCULATOR_ITEMS:
      return {
        ...state,
        items: action.payload.ps_calculator || [],
        loading: action.payload.loading,
      };
    case GET_PS_CALCULATOR_DOC_URL:
      return {
        ...state,
        docUrl: action.payload.docUrl,
        loading: action.payload.loading,
      };
    default:
      return state;
  }
}
